import { Observable } from "rxjs";
import NetworkService from "../network/networkService";
import { URLConfig } from "../network/urlStore";

export const uploadPicture = (
  resourceType: string,
  resourceId: string,
  file: File
): Observable<any> => {
  const url = `${URLConfig.getPicturesURL(resourceId, resourceType)}`;
  const formData = new FormData();
  formData.append("file", file);
  return new Observable((subscriber) => {
    NetworkService.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then(
      (res: unknown) => {
        const response = res as any;
        subscriber.next(response);
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while uploading  picture", error);
      }
    );
  });
};

export const deletePictures = (payload: {
  FileIds: string[];
  ResourceId: number;
  ResourceType: string;
  FileNames: string[];
}): Observable<any> => {
  const url = URLConfig.deletePicturesURL();
  return new Observable((subscriber) => {
    NetworkService.delete(url, undefined, undefined, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    }).then(
      (res: unknown) => {
        const response = res as any;
        subscriber.next(response);
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while deleting pictures", error);
      }
    );
  });
};